<template>
  <b-modal id="modal-add-user" hide-footer>
    <template #modal-header>
      <h4>
        {{ $t("companies.add-user") }}
      </h4>
    </template>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onSubmit)">
        <div class="new-user-info">
          <b-row align-h="center">
            <b-col md="12" sm="12">
              <b-row align-v="center">
                <!-- User -->
                <b-form-group
                  class="col-md-12"
                  :label="$t('user-college.user')"
                  label-for="user_id"
                >
                  <ValidationProvider
                    :name="$t('user-college.user')"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <v-select
                      v-model="data.user_id"
                      :placeholder="$t('user-college.user')"
                      :options="usersAll"
                      label="name"
                      :reduce="(item) => item.id"
                      :class="errors.length > 0 ? ' is-invalid' : ''"
                    >
                      <template
                        #selected-option="{ name, email, first_lastname }"
                      >
                        <div>
                          {{ name }} {{ first_lastname }}
                          <br />
                          <cite>{{ email }}</cite>
                        </div>
                      </template>
                      <template #option="{ name, email, first_lastname }">
                        {{ name }} {{ first_lastname }}
                        <br />
                        <cite>{{ email }}</cite>
                      </template>
                      <template #no-options="{}">
                        {{ $t("app.not-found") }}...
                      </template>
                    </v-select>
                    <div v-if="errors[0]">
                      <small class="text-danger">{{ errors[0] }}</small>
                    </div>
                  </ValidationProvider>
                </b-form-group>
              </b-row>
            </b-col>
          </b-row>
          <hr />
          <b-button
            class="float-right"
            :disabled="companiesLoading"
            variant="success"
            type="submit"
          >
            <span v-if="companiesLoading">
              <b-spinner small type="grow"></b-spinner>
              {{ $t("app.loading") }}...
            </span>
            <span v-else>
              {{ $t("app.save") }}
            </span>
          </b-button>
          <b-button
            class="float-right mr-1"
            @click="$bvModal.hide('modal-add-user')"
            variant="outline-danger"
            type="reset"
          >
            {{ $t("app.cancel") }}
          </b-button>
        </div>
      </form>
    </ValidationObserver>
  </b-modal>
</template>
<script>
import { core } from "@/config/pluginInit";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AddUser",
  mounted() {
    core.index();
    this.fetchUsersAll();
  },
  data() {
    return {
      data: {
        user_id: null,
      },
    };
  },
  methods: {
    ...mapActions({
      saveForm: "addUserToCompany",
      fetchUsersAll: "fetchUsersAll",
    }),
    async show() {
      this.reserForm();
      this.$bvModal.show("modal-add-user");
    },
    async onSubmit() {
      const resp = await this.saveForm({
        user_id: this.data.user_id,
        company_id: this.$route.params.id,
      });
      this.$bvModal.hide("modal-add-user");
      this.$emit("refresh");
      if (resp?.status === 201 || resp?.status === 200) {
        core.showSnackbar(
          "success",
          this.$t("companies.user-added-successfully")
        );
      }
      this.reserForm();
    },
    reserForm() {
      this.data = {
        user_id: null,
      };
    },
  },
  computed: {
    ...mapGetters({
      usersAll: "usersAll",
      companiesLoading: "companiesLoading",
    }),
  },
};
</script>
